module.exports = __webpack_public_path__ + "lp/img/select-orange.4c7dbf13.svg";